import { isUndefinedOrNull } from './compare'

export const sentence = (id, label) => translate => `${translate(id)} ${translate(label)}`
export const isEmpty = value => isUndefinedOrNull(value) || value === ''

export const isString = value => typeof value === 'string' || value instanceof String
